import { LOADING, useLoader } from '@/generic/loader';
import { initAccount, RULE_IMPORT, type User } from '@/supporting/account';

const canImportRules = (user: User): boolean =>
  user.organization.map((organization) => organization.authorities.has(RULE_IMPORT)).orElse(false);

export const useCanManageRules = (): boolean => {
  const { injectUsersRepository } = initAccount();
  const userLoader = useLoader(() => injectUsersRepository().currentUser(), []);

  if (userLoader === LOADING || userLoader instanceof Error) {
    return false;
  }

  return userLoader.fold({ error: () => false, success: canImportRules });
};
